import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-mobile",
  "use": "icon-mobile-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-mobile\"><defs><style type=\"text/css\"></style></defs><path d=\"M754.203 958.688H268.12c-44.744 0-81.014-36.27-81.014-81.014V148.55c0-44.744 36.27-81.014 81.014-81.014h486.083c44.744 0 81.014 36.27 81.014 81.014v729.124c0 44.745-36.27 81.014-81.014 81.014z m0-810.138H268.12v729.124h486.083V148.55z m-81.014 607.604H349.134v-526.59h324.055v526.59z m-121.521 81.014h-81.014v-40.507h81.014v40.507z\" p-id=\"8770\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/mobile.svg
// module id = ofrD
// module chunks = 1